<template>
    <b-card :no-body="true">
        <b-card-body class="p-0 clearfix">
            <i
                class="fa fa-dollar p-4 font-2xl mr-3 float-left"
                :class="bg()"
            ></i>
            <div class="h5 mb-0 pt-3" :class="tx()">{{ valor | currency }}</div>
            <div class="text-muted text-uppercase font-weight-bold font-xs">
                {{ titulo }}
            </div>
        </b-card-body>
    </b-card>
</template>

<script>
export default {
    props: {
        valor: {
            type: Number,
            default: () => 0
        },

        titulo: {
            type: String,
            default: () => 'A DEFINIR'
        },

        cor: {
            type: String,
            default: () => 'primary'
        }
    },

    data() {
        return {}
    },

    methods: {
        bg() {
            return `bg-${this.cor}`
        },

        tx() {
            return `text-${this.cor}`
        }
    }
}
</script>
